import React from "react";
import "../SpringLoader/spinner.css";

function SpringLoader({ containerStyle = {}, addedStyle = {} }) {
  return (
    <React.Fragment>
      <div className="half-circle-spinner" style={containerStyle}>
        <div className="circle circle-1" style={addedStyle}></div>
        <div className="circle circle-2" style={addedStyle}></div>
      </div>
    </React.Fragment>
  );
}

export default SpringLoader;
